/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateCardInstrument} from '../api'

export const useMutationUpdateCardInstrument = createReactQueryMutationHook('updateCardInstrument', updateCardInstrument)
